var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 35,
    viewBox: "0 0 96 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.787014 27.5755C2.56963 29.1875 4.21332 29.9367 6.59752 29.9367C9.02822 29.9367 10.6949 28.5973 10.6949 26.7814C10.6949 25.056 9.79229 24.0796 6.1115 23.3532C2.22233 22.5812 0.648297 21.2874 0.648297 18.8808C0.648297 16.4747 2.84747 14.6583 5.85681 14.6583C8.21806 14.6583 9.76913 15.294 11.4128 16.5883L10.6488 17.5188C9.12104 16.2248 7.59312 15.7256 5.81071 15.7256C3.4261 15.7256 1.85187 17.0649 1.85187 18.7222C1.85187 20.4473 2.7317 21.469 6.57457 22.241C10.3246 22.9901 11.8988 24.3067 11.8988 26.6225C11.8988 29.2329 9.65337 31.0039 6.52826 31.0039C3.93548 31.0039 1.94469 30.1638 0 28.4611L0.787014 27.5755Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0659 27.8028V20.2206H12.8611L12.3529 19.1988H14.0659V15.4983H15.2002V19.1988H18.8103L19.3189 20.2206H15.2002V27.6892C15.2002 29.3466 16.1958 29.9367 17.5615 29.9367C18.1403 29.9367 18.6263 29.8232 19.2978 29.5282V30.5723C18.6958 30.8449 18.1171 30.9812 17.3764 30.9812C15.5475 30.9812 14.0659 30.0048 14.0659 27.8028Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.828 25.0332V24.9878C30.828 22.1956 28.6983 19.9708 25.9666 19.9708C23.1656 19.9708 21.1515 22.2183 21.1515 24.9424V24.9878C21.1515 27.78 23.2812 30.0048 26.0129 30.0048C28.8138 30.0048 30.828 27.7573 30.828 25.0332ZM19.9245 25.0332V24.9878C19.9245 21.7412 22.4942 18.9263 26.0129 18.9263C29.5084 18.9263 32.0549 21.6958 32.0549 24.9424V24.9878C32.0549 28.2343 29.4855 31.0493 25.9666 31.0493C22.4712 31.0493 19.9245 28.2794 19.9245 25.0332Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0703 20.4285C37.646 20.1507 35.2094 22.4493 35.2094 26.2179V30.7768H34.0751V19.1988H35.2094V22.676C36.1355 20.6102 37.9289 19.2028 40.441 19.2028",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3897 33.9779L42.7833 33.0015C43.4082 33.2969 43.9176 33.4327 44.797 33.4327C46.0242 33.4327 46.8343 32.729 47.714 30.7086L42.0424 19.1989H43.3619L48.2696 29.551L52.5289 19.1989H53.7791L48.663 31.1852C47.6216 33.6144 46.4176 34.4772 44.7276 34.4772C43.825 34.4772 43.1767 34.3183 42.3897 33.9779Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7748 19.1988H56.0944L60.5624 29.5282L65.0765 19.1988H66.3495L61.0484 30.8677H60.0762L54.7748 19.1988Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1065 30.7767H69.2408V19.1989H68.1065V30.7767ZM67.9676 16.1794H69.3797V14.6583H67.9676V16.1794Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8577 19.1988H72.992V21.3555C73.7793 19.9933 75.0986 18.9262 77.2517 18.9262C80.2378 18.9262 81.9739 20.9243 81.9739 23.6938V30.7766H80.8396V23.898C80.8396 21.5144 79.474 19.9479 77.0894 19.9479C74.7744 19.9479 72.992 21.6736 72.992 24.0796V30.7766H71.8577V19.1988Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.6412 24.4431C93.4791 22.1047 92.1133 19.9481 89.4047 19.9481C87.0668 19.9481 85.2612 21.8775 85.0527 24.4431H93.6412ZM83.8489 25.0105V24.9651C83.8489 21.6054 86.2566 18.9263 89.451 18.9263C92.7613 18.9263 94.8681 21.56 94.8681 24.9878C94.8681 25.1921 94.8681 25.2605 94.845 25.4417H85.0527C85.2612 28.3248 87.3678 30.0048 89.6827 30.0048C91.5115 30.0048 92.7613 29.2103 93.7338 28.1889L94.521 28.8699C93.317 30.1412 91.9051 31.0493 89.6364 31.0493C86.5343 31.0493 83.8489 28.6201 83.8489 25.0105Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.6362 4.08726C93.6362 6.34451 91.7703 8.17452 89.4684 8.17452C87.1667 8.17452 85.3008 6.34451 85.3008 4.08726C85.3008 1.83002 87.1667 0 89.4684 0C91.7703 0 93.6362 1.83002 93.6362 4.08726Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.8204 9.27783H85.1125C83.9091 9.27783 82.9336 10.2345 82.9336 11.4146V18.4948L83.6345 17.8891C84.7069 16.9624 86.0873 16.4509 87.5168 16.4509H93.8204C95.0238 16.4509 95.9993 15.4945 95.9993 14.3144V11.4146C95.9993 10.2345 95.0238 9.27783 93.8204 9.27783Z",
    fill: "#FC7411"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3244 13.0905L88.2525 14.5318C88.0829 14.6112 87.8867 14.4901 87.8867 14.3057V11.4232C87.8867 11.239 88.0829 11.1177 88.2525 11.1974L91.3244 12.6386C91.518 12.7294 91.518 12.9997 91.3244 13.0905Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a0611ba97c005ba7e181535b6fad930e.svg";
export { ForwardRef as ReactComponent };